$(document).ready(() =>
  $(".cards-slider").each(function() {
    let $container = $(this);
    let isWideCardsSlider = $container.hasClass("wide-cards-slider");
    let $owlContainer = $(this).find(".owl-carousel");

    let ITEM_WIDTH = 220;
    if (isWideCardsSlider) { ITEM_WIDTH = 400; }

    let owlCarouselOptions = {
      // center: true
      items: 6,
      responsive: {
        [0]: {
          items: 1
        },
        [(2 * ITEM_WIDTH)]: {
          items: 2
        },
        [(3 * ITEM_WIDTH)]: {
          items: 3
        },
        [(4 * ITEM_WIDTH)]: {
          items: 4
        },
        [(5 * ITEM_WIDTH)]: {
          items: 5
        },
        [(6 * ITEM_WIDTH)]: {
          items: 6
        }
      },
      // autoWidth: true
      // loop: true
      margin: 10,
      nav: true,
      navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
      smartSpeed: 400,
      lazyLoad: true,
      onInitialized() {
        return setupDotDotDot($owlContainer.find(".owl-stage")[0]);
      }
    };

    let alreadyRendered = false;

    let shouldRender = () => st.domUtils.isElementInViewport($owlContainer[0]);

    let renderIfShould = _.throttle((function() {
      if (!alreadyRendered && shouldRender()) {
        $owlContainer.owlCarousel(owlCarouselOptions);
        alreadyRendered = true;
        $(window).off("scroll", renderIfShould);
      }
    }), 300);

    renderIfShould();
    $(window).on("scroll", renderIfShould)
  })
);



// WEBPACK FOOTER //
// ./app/webpack/frontend/initializers/cards_slider.js